import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InvoiceDrawerComponent } from '../components/invoice-drawer/invoice-drawer.component';
import { Invoice } from '../models/invoice.models';

type InvoiceGetData = {
  seller: string;
  orderId: string;
  tenantId: string;
  date: Date;
  email: string;
};
@Injectable({
  providedIn: 'root',
})
export class InvoiceDrawerManagerService {
  constructor(private dialog: MatDialog) {}

  onReceiptClick(invoice: Invoice) {
    const dialogRef = this.dialog.open(InvoiceDrawerComponent, {
      height: '100%',
      width: '300px',
      position: { right: '0px' },
      data: {
        ...invoice,
        close: () => dialogRef.close(),
      },
      disableClose: false,
      restoreFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  openRecipentFromOrder(input: InvoiceGetData) {
    const dialogRef = this.dialog.open(InvoiceDrawerComponent, {
      height: '100%',
      width: '300px',
      position: { right: '0px' },
      data: {
        invoiceGetData: input,
        close: () => dialogRef.close(),
      },
      disableClose: false,
      restoreFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }
}
